export default __webpack_public_path__ + "static/media/request_in_progress.91dad9a4.svg";